import React, { useState, useEffect, useRef } from "react";
import { useParams } from "react-router-dom";
import { Spin } from "antd";
import { PageLayout } from "../../layout/PageLayout/PageLayout";
import { useApplicationContext } from "../../application/ApplicationContext";
import { PdfPreview } from "../../components/PdfPreview/PdfPreview";
import { formatDate, formatTime } from "../../core/Utility";
import { getInvoice } from "../../services/InvoiceService";
import { getInvoiceReportTemplate } from "../../document-templates/InvoiceReportTemplate";
import CustomButton from "../../components/AccommodationData/CustomButton/CustomButton";
import "./InvoiceOverviewPage.scss";

const InvoiceOverviewPage = () => {
  const { setBreadcrumb } = useApplicationContext();
  const { id } = useParams();
  const [activeSpinner, setActiveSpinner] = useState<boolean>(false);
  const [invoice, setInvoice] = useState<any>();
  const [pdfData, setPdfData] = useState<any>();
  const [registrationId, setRegistrationId] = useState<string>("");

  const downloadPdfDocument = useRef(null);
  const printPdfDocument = useRef(null);
  const sendPdf = useRef(null);

  useEffect(() => {
    if (id !== undefined) {
      setActiveSpinner(true);
      setBreadcrumb(["Fakture", "Pregled profakture"]);

      getInvoice(id)
        .then((response) => {
          const data = response.data.result;
          setInvoice(data);

          let newData: any = { ...data };

          let country =
            newData?.registration == null
              ? newData?.registrationCompany?.companyCountry
              : newData?.itemsBillRegistration[0].registrations[0].country;

          let currentCurrencyEUR = 117.2; /// - trenutni srednji kurs EUR

          if (country !== "Srbija") {
            let transformed = newData?.itemsBillRegistration?.map(
              (registration: any) => {
                let priceObj: any = {
                  32000: 299,
                  59000: 520,
                  68001: 595,
                  108000: 950,
                  90000: 798,
                  56000: 510,
                  71900: 610,
                  55500: 470,
                  17700: 150,
                  8400: 70,
                  111000: 940,
                  26100: 220,
                  ///// SDO 24
                  74000: 657,
                  65000: 581,
                  38000: 352,
                  124001: 1100,
                  104000: 942,
                  68000: 636,
                  //// DOT 24
                  48500: 440,
                  83000: 760,
                  14500: 153,
                  /// AIDA 25
                  75000: 645,
                  124000: 1170,
                  /// DOT 25
                  54500: 466,
                  40500: 346,
                  95000: 812,
                  67000: 572,
                  17500: 150,
                  /// SDO 25
                  44000: 375,
                  73000: 625,
                  79500: 680,
                  84000: 720,
                  120000: 1030,
                  136000: 1170,
                  /// AIDA 26
                  77001: 660,
                  132000: 1140,
                  /// DOT 26
                  45500: 387,
                  59500: 506,
                  77000: 656,
                  105000: 894,
                  /// SDO 26
                  46000: 393,
                  86000: 736,
                  122000: 1042,
                  138000: 1164,
                };

                if (registration.price in priceObj) {
                  registration.price = priceObj[registration.price];
                } else {
                  registration.price = (
                    registration.price / currentCurrencyEUR
                  ).toFixed(2);
                }

                return registration;
              },
            );

            data.country = "Inostranstvo";

            data.accommodationPrice =
              transformed.reduce(
                (acc: any, item: any) => acc + Number(item.price),
                0,
              ) + (data.internationalPayment || 0);
          }

          //// - kad se bude zavrsio dogadjaj, izbrisati funkciju samo proslijediti 'data' - jer cu cene zakucane za ovaj dogadjaj

          setPdfData(getInvoiceReportTemplate(data));
          setRegistrationId(
            data.registration == null
              ? data.registrationCompany.id
              : data.registration.id,
          );
        })
        .finally(() => setActiveSpinner(false));
    }
  }, []);

  return (
    <PageLayout>
      <Spin spinning={activeSpinner}>
        <div className="invoice-overview">
          <div className="btn-container header-btn-container">
            <CustomButton
              danger={false}
              htmlType={"submit"}
              type={"primary"}
              function={() => {
                if (downloadPdfDocument.current) {
                  // @ts-ignore
                  downloadPdfDocument.current();
                }
              }}
              text={"PDF"}
            />
            <CustomButton
              danger={false}
              htmlType={"submit"}
              type={"primary"}
              function={() => {
                if (printPdfDocument.current) {
                  // @ts-ignore
                  printPdfDocument.current();
                }
              }}
              text={"Štampa"}
            />
            <CustomButton
              danger={false}
              htmlType={"submit"}
              type={"primary"}
              function={() => {
                if (sendPdf.current) {
                  // @ts-ignore
                  sendPdf.current();
                }
              }}
              text={"Pošalji"}
            />
          </div>
          <div className="pdf-container">
            <div>
              <PdfPreview
                pdfDefinition={pdfData}
                downloadDocument={downloadPdfDocument}
                printDocument={printPdfDocument}
                sendDocument={sendPdf}
                documentName={`Profaktura ${
                  invoice?.documentId +
                  " " +
                  formatDate(new Date()) +
                  "_" +
                  formatTime(new Date())
                }.pdf`}
                registrationId={registrationId}
              />
            </div>
          </div>
        </div>
      </Spin>
    </PageLayout>
  );
};

export default InvoiceOverviewPage;
